export const FoundABug = {
  question: "How do I report a bug or data problem?",
  answer: `
The FireHydrant V2MOM app is new software, so there will certainly be some bugs. You can report bugs through the [Firestation portal](https://firehydrant.atlassian.net/servicedesk/customer/portal/2/group/9/create/70). Please include details on how you encountered the bug and if you can reproduce it reliably. If you need a piece of data updated caused by a bug, you can submit a ticket.

Your patience and understanding when reporting bugs is appreciated.
`
}